// Drains the offline mutation queue by replaying each operation against the live API.
// Uses raw fetch (not the axios instance) to avoid re-triggering the offline interceptor.
import { getPending, markSyncing, markFailed, removeOp } from './offlineDB';
import { getSubdomain } from './subdomain';

export async function drainQueue(onProgress) {
  const pending = await getPending();
  if (!pending.length) return { synced: 0, failed: 0 };

  const authRaw  = localStorage.getItem('staynivo-auth') || '{}';
  const token    = JSON.parse(authRaw)?.state?.accessToken;
  const subdomain = getSubdomain();
  const baseUrl   = process.env.REACT_APP_API_URL || '/api';

  let synced = 0;
  let failed = 0;
  let checkoutsSynced = 0;

  for (const op of pending) {
    await markSyncing(op.id);
    try {
      const resp = await fetch(`${baseUrl}${op.url}`, {
        method:  op.method.toUpperCase(),
        headers: {
          'Content-Type':       'application/json',
          'X-Idempotency-Key':  op.idempotencyKey,
          ...(token    && { Authorization:     `Bearer ${token}` }),
          ...(subdomain && { 'X-Hotel-Subdomain': subdomain }),
        },
        body: op.body != null ? JSON.stringify(op.body) : undefined,
      });

      if (resp.ok || (resp.status >= 200 && resp.status < 300)) {
        const isCheckout = op.method.toUpperCase() === 'PATCH' &&
          /\/bookings\/[^/]+\/checkout$/.test(op.url);
        if (isCheckout) checkoutsSynced++;
        await removeOp(op.id);
        synced++;
      } else if (resp.status >= 400 && resp.status < 500) {
        // Client error — the op will never succeed; drop it rather than block the queue
        await removeOp(op.id);
        failed++;
      } else {
        // Server error — reset to pending for the next sync attempt
        await markFailed(op.id);
        failed++;
      }
    } catch {
      await markFailed(op.id);
      failed++;
    }
    onProgress?.({ synced, failed, total: pending.length });
  }

  return { synced, failed, checkoutsSynced };
}

export async function getPendingCount() {
  const { countPending } = await import('./offlineDB');
  return countPending();
}
